import React from "react";
import { motion } from "framer-motion";
import "./BulletGrid.css";

/* ============================================================
   BulletGrid — interactive icon-led list
   Replaces plain checkmark bullet rails with a richer 2-column
   grid: icon + headline + body. Hover: accent slides in from
   left, icon nudges, line color shifts orange. Stagger-reveal
   on viewport entry.

   Props:
     · variant: "do" (positive checks) | "dont" (negative crosses)
     · items: [{ icon: lucide-icon, t: "headline", b?: "body" }]
   ============================================================ */

const easeOut = [0.22, 1, 0.36, 1];

export default function BulletGrid({ variant = "do", items = [] }) {
  return (
    <motion.ul
      className={`bg ${variant === "dont" ? "bg--dont" : "bg--do"}`}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
      variants={{ show: { transition: { staggerChildren: 0.05 } } }}
    >
      {items.map((it, i) => {
        const Icon = it.icon;
        return (
          <motion.li
            key={it.t}
            className="bg__item"
            variants={{
              hidden: { opacity: 0, y: 14 },
              show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: easeOut } },
            }}
          >
            <span className="bg__icon" aria-hidden="true">
              {Icon && <Icon size={20} strokeWidth={1.8} />}
            </span>
            <div className="bg__body">
              <h3 className="bg__t">{it.t}</h3>
              {it.b && <p className="bg__b">{it.b}</p>}
            </div>
            <span className="bg__line" aria-hidden="true" />
          </motion.li>
        );
      })}
    </motion.ul>
  );
}
